'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/app-skeleton';
export function MarketTradersSkeleton() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-wrap items-center gap-2"><Skeleton className="h-8 w-16" /><Skeleton className="h-8 w-20" /><Skeleton className="h-8 w-24" /></div>;
    t1 = <Skeleton className="h-6 w-full" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-3">{t0}{t1}<div className="flex flex-col gap-2">{Array.from({
          length: 8
        }, _temp)}</div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(_, i) {
  return <div key={`row-${String(i)}`} className="flex w-full items-center gap-3 rounded-card border border-border-primary bg-background-primary p-3"><Skeleton className="size-6 shrink-0" /><Skeleton className="size-8 shrink-0 rounded-full" /><Skeleton className="h-4 min-w-0 flex-1" /><Skeleton className="h-4 w-24 shrink-0 xl:w-32" /></div>;
}